/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type reconciliation_DebtorPeriodSummaryResponse = {
    /**
     * ClosingBalanceCents is what the debtor owes at the end of the last month.
     */
    closingBalanceCents?: number;
    /**
     * CreditedCents is the account corrections booked in the range, a credit
     * positive; a reverted correction books its inverse when reverted.
     */
    creditedCents?: number;
    currency: string;
    debtorAccountId: string;
    /**
     * DraftInvoicedCents is the part of InvoicedCents that comes from invoices
     * still in draft, so a reconciliation can say "of which drafts" (#1989 C2).
     */
    draftInvoicedCents?: number;
    from: string;
    invoiceCount?: number;
    /**
     * InvoicedCents is the debtor's share of the invoices booked in the range
     * (finalized, or a draft by its invoice date; cancelled ones excluded).
     */
    invoicedCents?: number;
    /**
     * Kind is the debtor's side of every figure: parent (family or contact)
     * or subsidy (subsidy office).
     */
    kind: reconciliation_DebtorPeriodSummaryResponse.kind;
    /**
     * OpeningBalanceCents is what the debtor owed before the first month.
     */
    openingBalanceCents?: number;
    /**
     * PaidCents is cash received minus refunds paid back to the debtor.
     */
    paidCents?: number;
    paymentCount?: number;
    receivedCents?: number;
    refundedCents?: number;
    /**
     * SubsidyInvoicedCents is, for a parent debtor, the subsidy offices' share
     * of the same invoices; not part of the debtor's balance. 0 for an office.
     */
    subsidyInvoicedCents?: number;
    to: string;
};
export namespace reconciliation_DebtorPeriodSummaryResponse {
    /**
     * Kind is the debtor's side of every figure: parent (family or contact)
     * or subsidy (subsidy office).
     */
    export enum kind {
        PARENT = 'parent',
        SUBSIDY = 'subsidy',
    }
}

